import { render, staticRenderFns } from "./UpdateStatusDialog.vue?vue&type=template&id=564c200e&scoped=true"
import script from "./UpdateStatusDialog.vue?vue&type=script&lang=js"
export * from "./UpdateStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateStatusDialog.vue?vue&type=style&index=0&id=564c200e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564c200e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564c200e')) {
      api.createRecord('564c200e', component.options)
    } else {
      api.reload('564c200e', component.options)
    }
    module.hot.accept("./UpdateStatusDialog.vue?vue&type=template&id=564c200e&scoped=true", function () {
      api.rerender('564c200e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Importer/components/UpdateStatusDialog.vue"
export default component.exports